"use client";

import dynamic from "next/dynamic";

export const TechStack = dynamic(() => import("@/modules/marketing/home/components/tech-stack"), { ssr: false });
export const OpticalPrism = dynamic(() => import("@/modules/marketing/home/components/optical-prism").then(mod => mod.OpticalPrism), { ssr: false });

